<template>
    <div>
        <div class="fixed bottom-5 lg:bottom-10 right-0 cursor-pointer" v-if="!displayChatbot" @click="displayChatbot=true">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 fill-current text-indigo-700" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clip-rule="evenodd" />
            </svg>
        </div>
        <transition name="fade">
            <div class="fixed bottom-0 right-0 w-full flex justify-end" v-if="displayChatbot">
                <div class="w-10/12 md:w-72 lg:w-80 shadow-md">
                    <div class="h-10 bg-indigo-700 flex items-center px-2 justify-between rounded-t">
                            <span class="text-white">AI Assistant</span>
                            <svg xmlns="http://www.w3.org/2000/svg" @click="displayChatbot=false" class="h-5 w-5 stroke-current text-gray-100 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                    </div>
                    <div class="messages h-80 bg-indigo-100 p-2 overflow-auto" v-chat-scroll="{always: true, smooth: true, scrollonremoved:true}">
                        <div class="flex message" :class="data.reply ? 'justify-start' : 'justify-end'" v-for="(data, index) in messages" :key="index">
                            <div style="max-width:80%" class="text-sm px-2 py-1 mt-3 rounded-sm relative" :class="data.reply ? 'bg-white text-gray-900 rounded-tl-none' : 'bg-indigo-500 text-white rounded-br-none'">
                                <div class="h-3 w-3 absolute" :class="data.reply ? 'bot-msg bg-white -top-2.5 left-0' : 'user-msg bg-indigo-500 -bottom-2.5 right-0'"></div>
                                {{ data.message }}
                            </div>
                        </div>
                        <div class="flex justify-start" v-if="displayTyping">
                            <div class="bg-white text-gray-900 text-sm max-w-9/12 px-2 py-1 mt-3 rounded-sm rounded-tl-none relative">
                                <div class="bot-msg h-3 w-3 bg-white absolute -top-3 left-0"></div>
                                <div class="wave relative text-center">
                                    <span class="dot w-2 h-2 inline-block rounded-full mr-1 bg-gray-400"></span>
                                    <span class="dot w-2 h-2 inline-block rounded-full mr-1 bg-gray-400"></span>
                                    <span class="dot w-2 h-2 inline-block rounded-full mr-1 bg-gray-400"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="h-12 bg-white flex items-center justify-between border-t border-indigo-200">
                        <input type="text" v-model="message" v-on:keyup.enter="sendMessage" class="w-11/12 h-full outline-none px-2" placeholder="Type here..." autofocus>
                        <img class="w-6 h-6 cursor-pointer mr-1" @click="sendMessage" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABMUlEQVRIie3VPS8EURQG4EdWgkZ2RSSi1fhs/QqlTnRKLZ2o/AetklZHSUdJ4yMRiUJJwkbYVcxMTGKHmXFnbeFNTm43z51zbu7lj1KL16F4bXUbHsQFGjjHc7c2AAdoo4k9LHQLXo3hdJ1iBf1VwmN464C3cY8tjFaFn2TASTWxi/nQ8PoPcLqOsSTQGCYLwEndYAMjv8UvSuBtvIjGMFsW3i4JdxpDTYEsBICTuhKNoZEH7sNdQLyNJ+xgJo10yrjP+ztkWriNN9NbuRa21e84xKLsLpsPCD6KZjuV5283A4CXotNczwMmOSuJteRoZ1Ym4g+Uaed0USydtQJgocvhpxzlAEtdh9+ljtcM7MvNEzLLHcBrgZ6877KvwnZmZQAPovd0rmosnWGBTud/ei4fG4YF6Mo3UToAAAAASUVORK5CYII="/>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
import axios from 'axios'
export default {
    data(){
        return {
            displayChatbot: false,
            message: '',
            displayTyping: false,
            messages: [
                {
                    message: `Hi.. I am Debarshi's AI assistant! How can I help you!`,
                    reply: true
                }
            ]
        }
    },
    methods: {
        sendMessage(){
            if(this.message.trim()){
                const message = this.message
                this.messages.push({
                    message: this.message,
                    reply: false
                })
                this.message = ''
                this.displayTyping = true
                axios.post("https://portfolio-debarshi-api.herokuapp.com/api/v1/chat", {
                    message
                }).then(response => {
                    this.messages.push({
                        message: response.data.reply,
                        reply: true
                    })
                    this.displayTyping = false
                }).catch(() => {
                    this.displayTyping = false
                    this.messages.push({
                        message: `I can't answer any question right now! If you have any important query, please mail - debarshi121@gmail.com`,
                        reply: true
                    })
                })
            } else{
                console.log('Message is required!')
            }
        }
    }
}
</script>



<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .messages::-webkit-scrollbar {
      width: 5px;
      cursor: pointer;
    }

    .messages::-webkit-scrollbar-track {
      background-color: rgba(229, 231, 235, var(--bg-opacity));
      cursor: pointer;
    }

    .messages::-webkit-scrollbar-thumb {
      cursor: pointer;
      background-color: #a8a8a8;
    }
    .bot-msg{
        clip-path: polygon(100% 100%, 0 40%, 0 100%);
    }
    .user-msg{
        clip-path: polygon(100% 0, 0 0, 100% 60%);
    }

    .dot{
        animation: wave 1.3s linear infinite;
    }

    .dot:nth-child(2) {
		animation-delay: -1.1s;
	}

	.dot:nth-child(3) {
		animation-delay: -0.9s;
	}

    @keyframes wave {
        0%, 60%, 100% {
            transform: initial;
        }

        30% {
            transform: translateY(-6px);
        }
    }
</style>